import React, { useState } from 'react';
import { useMetadata } from '../../context/MetadataContext';
import { getValue } from '../../utils/getValue';
import { useGameState } from '../../context/GameStateContext';
import { useGlobalError } from '../../context/GlobalErrorContext';
import FormattedTime from '../../utils/FormattedTime';
import {
  ArrowLeft,       // Back
  Play             // Start
} from 'lucide-react';



const MirrorPuzzleInfo = () => {
  const [loading, setLoading] = useState(false);
  const { getText } = useMetadata();
  const { gameData, rejectPuzzle, startPuzzle } = useGameState();
  const { triggerError } = useGlobalError();

  if (!gameData?.state) {
    triggerError({
      type: 'non-critical',
      message: 'MirrorPuzzleInfo component rendered without puzzle data. This indicates a routing/status determination error.'
    });
    return null;
  }

  const handleRejectPuzzle = () => {
    rejectPuzzle();
  };

  const handleStartPuzzle = () => {
    startPuzzle();
  }

  return (
    <div className="dataContainer">
      <div className="containerHeader">
        <h3>{getValue(gameData, 'messages.pre_play')}</h3>
      </div>

      <div className="dataContent">
        {/* Puzzle Details */}
        <div className="contentGroup">
          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.style')}:</span>
            <span className="dataValue">
              {(() => {
                const v = getValue(gameData, 'puzzle.style');
                if (!v) return '';
                const displayName = v.charAt(0).toUpperCase() + v.slice(1);
                return (
                  <a
                    href={`https://gridrank.games/guides/${v.toLowerCase()}.html`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {displayName}
                  </a>
                );
              })()}
            </span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.size')}:</span>
            <span className="dataValue">{getValue(gameData, 'puzzle.size')}</span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.difficulty')}:</span>
            <span className="dataValue">{getValue(gameData, 'puzzle.difficulty')}</span>
          </div>
        </div>

        {/* Previous Performance Details */}
        <div className="contentGroup">
          <div className="groupHeader">
            <h3>{getText('mirror_mode.previous_performance')}</h3>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.status')}:</span>
            <span className="dataValue">{getText('common_text.solved')}</span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.date')}:</span>
            <span className="dataValue">
              {new Date(getValue(gameData, 'stats.previous_solved_ts') * 1000).toLocaleString()}
            </span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.total_time')}:</span>
            <span className="dataValue">
              <FormattedTime seconds={getValue(gameData, 'stats.previous_total_time')} />
            </span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.moves')}:</span>
            <span className="dataValue">{getValue(gameData, 'stats.previous_move_count', 'N/A')}</span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.hints')}:</span>
            <span className="dataValue">{getValue(gameData, 'stats.previous_hint_count', 'N/A')}</span>
          </div>
        </div>

      </div>

      <div className="actionButtonContainer">
        <button
          className="iconButton secondaryButton"
          onClick={handleRejectPuzzle}
          title={getText('common_text.back')}
          aria-label={getText('common_text.back')}
        >
          <ArrowLeft className="buttonIcon" />
        </button>

        <button
          className="iconButton primaryButton"
          onClick={handleStartPuzzle}
          disabled={loading}
          title={loading ? getText('common_text.loading') : getText('common_text.start')}
          aria-label={loading ? getText('common_text.loading') : getText('common_text.start')}
        >
          <Play className="buttonIcon" />
        </button>
      </div>
    </div>
  );
};

export default MirrorPuzzleInfo;
